export const objectToArrayOfObjects = (obj: object): Array<object> => {
    const arr = Object.keys(obj).map((key) => ({ [key]: obj[key as keyof typeof obj] }));

    return arr;
}